import { Place } from '@itc-mod/supply/shared';
import { z } from 'zod';
import { RequestView } from './requests.ts';
import { BoardEntry, BoardPeriod } from './boards.ts';
import { Line, Pickup } from './schemas.ts';

// The shapes of Donations' calls for other modules (public.ts, ADR 0013, plan 2D).
// Donations knows nothing about Ops: a link is an opaque id it keeps on the pickup.

/** One incoming donation or delivery. */
export const PickupRef = z.object({ kind: z.enum(['donation', 'delivery']), id: z.string().max(15) });
export type PickupRef = z.infer<typeof PickupRef>;

export const PickupResult = z.object({
  kind: z.enum(['donation', 'delivery']),
  id: z.string(),
  /** Who it's from: the donors, or the delivery's source. */
  from: z.string(),
  lines: z.array(Line),
  /** The gift as text: `3× 8 SCU RMC`, or an amount of aUEC. */
  what: z.string(),
  pickup: Pickup.nullable(),
  /** Where it goes. */
  place: Place.nullable(),
  /** Still waiting to come in. */
  open: z.boolean(),
});
export type PickupResult = z.infer<typeof PickupResult>;

export const LinkPickupInput = PickupRef.extend({ op: z.string().max(15) });
export const LinkPickupResult = z.object({ ok: z.literal(true) });

/** `contributions`: the credited donors of a period, as the full leaderboard has them, opted-out ones marked. */
export const ContributionsInput = z.object({ period: BoardPeriod });
export const ContributionsResult = z.object({ donors: z.array(BoardEntry), hidden: z.array(z.string()) });

/** `overview`: Active requests with their progress and names, and donations accepted since a time (plan 2E R13, R14). */
export const OverviewInput = z.object({ since: z.iso.datetime() });
export const OverviewResult = z.object({ requests: z.array(RequestView), people: z.record(z.string(), z.string()), accepted: z.number().int() });
export type OverviewResult = z.infer<typeof OverviewResult>;
